import { ThemeUICSSObject } from '@apia/theme';
import calendar from './stylesObject/calendar';

const stylesObject: () => ThemeUICSSObject = () => ({
  // Root styles
  ...calendar(),
});
export default stylesObject;
